import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import idx from 'idx';
import partial from 'lodash/partial';
import { getProject } from 'project/ducks/project';
import { fetchMessagesIfNeeded, createMessageRequest } from 'common/ducks/message';
import { adminCreateMessage } from 'admin/ducks/projects';
import { ADMIN_ROOT } from 'common/variables';
import { isCollaborator } from 'project/utils';
import MessageEditor from 'common/components/message_editor';

export function mapStateToProps(state, { location, project }) {
  const { message: { streamId }, user, admin } = state;
  const userId = user.profile_data.id;
  const isAdmin = location.pathname.indexOf(ADMIN_ROOT) !== -1;
  const projectData = project || (isAdmin? admin.projects.currentProject : getProject(state));

  return {
    isClient: idx(projectData, _ => _.client) === userId,
    isCollaborator: isCollaborator(projectData),
    hasCollaborators: idx(projectData, _ => _.collaboration_allowed),
    isAdmin,
    streamId,
  };
}

export function mapDispatchToProps(dispatch, { wrapup, location, params }) {
  const isAdmin = location.pathname.indexOf(ADMIN_ROOT) !== -1;
  const adminCreate = partial(adminCreateMessage, params.projectId);

  return bindActionCreators({
    createMessageRequest: isAdmin && !wrapup ? adminCreate : createMessageRequest,
    fetchMessagesIfNeeded,
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MessageEditor));



// WEBPACK FOOTER //
// ./common/containers/message_editor.jsx